import { useParams } from 'react-router-dom';
import { useAppSelector } from '@hooks/reduxHooks';

type AdminIdTenantResult = {
    clientId: number;
    tenantAlias: string;
    isClientIdAndTenantAliasAvailable: boolean;
};

export const useGetClientIdAndTenantAlias = (): AdminIdTenantResult => {
    const { clientId, tenantAlias } = useParams<{ clientId?: string; tenantAlias?: string }>();
    const clientIdFromStore = useAppSelector((s) => s.adminCenterClientInfo.clientInfoId);
    const tenantAliasFromStore = useAppSelector((s) => s.adminCenterTenantInfo.tenantAlias);

    const clientIdToNum = clientId !== undefined && /^\d+$/.test(clientId) ? Number(clientId) : 0;

    const resolvedClientId = clientIdToNum || clientIdFromStore || 0;

    const resolvedTenantAlias = (tenantAlias ?? tenantAliasFromStore ?? '').trim();

    const isClientIdAndTenantAliasAvailable = resolvedClientId > 0 && resolvedTenantAlias.length > 0;

    return {
        clientId: resolvedClientId,
        tenantAlias: resolvedTenantAlias,
        isClientIdAndTenantAliasAvailable,
    };
};
